import { Inject, Injectable } from '@angular/core';

import type { ApiClient } from '@packages/shared-utils';
import { API_CLIENT } from './api-client.provider';
import type { ApiAdminCategory, ApiCategory, ApiCity, CreateCategoryPayload } from './api.types';

@Injectable({ providedIn: 'root' })
export class ReferenceApiService {
  constructor(@Inject(API_CLIENT) private readonly api: ApiClient) {}

  cities(): Promise<{ items: ApiCity[] }> {
    return this.api.get<{ items: ApiCity[] }>('/reference/cities');
  }

  categories(): Promise<{ items: ApiCategory[] }> {
    return this.api.get<{ items: ApiCategory[] }>('/reference/categories');
  }

  adminCategories(): Promise<{ items: ApiAdminCategory[] }> {
    return this.api.get<{ items: ApiAdminCategory[] }>('/reference/admin/categories');
  }

  createAdminCategory(payload: CreateCategoryPayload): Promise<ApiAdminCategory> {
    return this.api.post<ApiAdminCategory>('/reference/admin/categories', payload);
  }
}